import axios from 'axios';
import { api } from '../config';

const DIVISIONS_KEY = 'system_divisions';

export const DEFAULT_DIVISIONS = [
  'MOIM',
  'MODP',
  'MOLM',
  'MOSD',
  'MONM',
  'MOTR',
  'MOSE',
];

/** Sync read from localStorage cache (used in dropdowns that can't await). */
export const getDivisions = (): string[] => {
  try {
    const saved = localStorage.getItem(DIVISIONS_KEY);
    if (saved) {
      const parsed = JSON.parse(saved);
      if (Array.isArray(parsed) && parsed.length > 0) return [...parsed].sort();
    }
  } catch {}
  return [...DEFAULT_DIVISIONS].sort();
};

/** Fetch from API and refresh cache. Returns sorted list. */
export const fetchDivisions = async (): Promise<string[]> => {
  try {
    const res = await axios.get(api('/api/divisions/list'));
    const list: string[] = res.data;
    localStorage.setItem(DIVISIONS_KEY, JSON.stringify(list));
    return [...list].sort();
  } catch {
    return getDivisions();
  }
};

export const addDivision = async (code: string): Promise<void> => {
  await axios.post(api('/api/divisions/add'), { code });
  await fetchDivisions();
};

export const removeDivision = async (code: string): Promise<void> => {
  await axios.delete(api(`/api/divisions/remove/${encodeURIComponent(code)}`))
  await fetchDivisions();
};

/** @deprecated use fetchDivisions + addDivision/removeDivision */
export const saveDivisions = (divs: string[]): void => {
  localStorage.setItem(DIVISIONS_KEY, JSON.stringify(divs));
};

export const getUserDivisionKey = (email: string): string =>
  `user_div_${email.toLowerCase()}`;

export const getUserDivision = (email: string): string => {
  return localStorage.getItem(getUserDivisionKey(email)) || '';
};

export const saveUserDivision = (email: string, division: string): void => {
  localStorage.setItem(getUserDivisionKey(email), division);
};

